// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GET_ASSET as ACTION_MONDOO_POLICY_ASSETSTORE_GETASSET } from "~/lib/iam/actions/mondoo/policy/AssetStore/GetAsset/action";
import { GET_ASSIGNED_POLICIES as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETASSIGNEDPOLICIES } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetAssignedPolicies/action";
import { GET_LATEST_SCAN_UPLOAD as ACTION_MONDOO_POLICY_ASSETSTORE_GETLATESTSCANUPLOAD } from "~/lib/iam/actions/mondoo/policy/AssetStore/GetLatestScanUpload/action";
import { GET_ORGANIZATION as ACTION_MONDOO_CAPTAIN_CAPTAIN_GETORGANIZATION } from "~/lib/iam/actions/mondoo/captain/Captain/GetOrganization/action";
import { GET_POLICIES_FOR_ANALYTICS as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETPOLICIESFORANALYTICS } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetPoliciesForAnalytics/action";
import { GET_RESOURCE_CONTACTS as ACTION_MONDOO_CAPTAIN_CAPTAIN_GETRESOURCECONTACTS } from "~/lib/iam/actions/mondoo/captain/Captain/GetResourceContacts/action";
import { GET_SPACE as ACTION_MONDOO_CAPTAIN_CAPTAIN_GETSPACE } from "~/lib/iam/actions/mondoo/captain/Captain/GetSpace/action";
import { GET_WORKSPACE as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETWORKSPACE } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetWorkspace/action";
import { LIST_ASSET_POLICIES as ACTION_MONDOO_POLICY_ASSETSTORE_LISTASSETPOLICIES } from "~/lib/iam/actions/mondoo/policy/AssetStore/ListAssetPolicies/action";

export const allowedActions = [
  ACTION_MONDOO_CAPTAIN_CAPTAIN_GETORGANIZATION,
  ACTION_MONDOO_CAPTAIN_CAPTAIN_GETRESOURCECONTACTS,
  ACTION_MONDOO_CAPTAIN_CAPTAIN_GETSPACE,
  ACTION_MONDOO_POLICY_ASSETSTORE_GETASSET,
  ACTION_MONDOO_POLICY_ASSETSTORE_GETLATESTSCANUPLOAD,
  ACTION_MONDOO_POLICY_ASSETSTORE_LISTASSETPOLICIES,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETASSIGNEDPOLICIES,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETPOLICIESFORANALYTICS,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETWORKSPACE,
] as const;
